import {useMemo} from "react";
import {useSetState} from "ahooks";
import ReactECharts from 'echarts-for-react'
import {SSegmentedTabs, STitle} from "shj-components";

import styles from './index.module.less'
import {isArray} from "lodash-es";
import dayjs from "dayjs";

export default function OutGoingCall(props) {
    const [state, setState] = useSetState<any>({
      currentType: 'callChart',
      chartData: {
        callChart: isArray(props.callChart) ? props.callChart : [],
        answerRateChart: isArray(props.answerRateChart) ? props.answerRateChart : [],
        callDurationChart: isArray(props.callDurationChart) ? props.callDurationChart : [],
      },
      typeData: [
        {value: 'callChart', label: '平均拨打数趋势图'},
        {value: 'answerRateChart', label: '平均接通率'},
        {value: 'callDurationChart', label: '平均通话时长'}
      ],
    })

    const resultData = useMemo(() => {
      const data1 = [], data2 = [], dates = [];
      (props[state.currentType] || [])?.forEach(item => {
        data1.push(item['thisMonth'])
        data2.push(item['lastMonth'])
        dates.push(item.date)
      })
      return {dates, data1, data2}
    }, [props, state.currentType])

    const option = {
      tooltip: {
        trigger: 'axis',
        formatter: function (params) {
          // console.log(params)
          return `
      <div style="border-radius: 5px; background: #FFF">
        <div style="color: #2D2D2E; margin-bottom: 5px">${dayjs().format('YYYY') + '-' + params[0].name}</div>
        <div style="padding: 5px 10px; 
          width: 210px;
          background: #fff;
          box-shadow: 6px 0 20px 0 #2257BC1A; 
          margin-bottom: 5px; 
          border-radius: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center">
          <div style="display: flex; align-items: center">
            <div style="background: #0064FF; width: 8px; height: 8px; margin-right: 5px; border-radius: 10px"></div>
            <span style="color: #4E5969">本月</span> 
          </div>
          <span style="color: #1D2129; font-weight: bolder">${params[0].value + (state.currentType === 'answerRateChart' ? '%' : '')}</span>
        </div>
         <div style="padding: 5px 10px; 
          width: 210px;
          background: #fff;
          box-shadow: 6px 0 20px 0 #2257BC1A; 
          margin-bottom: 5px; 
          border-radius: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center">
          <div style="display: flex; align-items: center;;">
            <div style="background: #A6CEE3; width: 8px; height: 8px; margin-right: 5px; border-radius: 10px;"></div>
            <span style="color: #4E5969">上月</span> 
          </div>
          <span style="color: #1D2129; font-weight: bolder">${params[1].value + (state.currentType === 'answerRateChart' ? '%' : '')}</span>
        </div>
      </div>
    `;
        },
        padding: 10,
      },
      legend: {
        bottom: 0,
        icon: 'circle', // 修改图标形状为矩形（原为默认圆形）
        itemHeight: 8,
        itemGap: 20,
        selectorButtonGap: 5,
        itemStyle: {
          padding: 0
        },
        textStyle: {
          fontSize: 14,
        }
      },
      grid: {
        left: 15,
        right: 15,
        bottom: 30,
        containLabel: true,
        lineStyle: {
          color: '#eee',       // 网格线颜色
          width: 1,            // 线宽
          type: 'dashed',      // 虚线类型
          opacity: 0.8         // 透明度
        }
      },
      xAxis: [
        {
          type: 'category',
          data: resultData.dates,
          axisPointer: {
            lineStyle: {
              color: '#4080FF',
              width: 2,
            }
          },
          splitLine: {
            show: true
          }
        },
      ],
      yAxis: [
        {
          type: 'value',
          min: 0,
          max: 100,
          axisLabel: {
            formatter: '{value}',
            color: '#666'
          },
        }
      ],
      series: [
        {
          name: `本月`,
          type: 'line',
          smooth: true,
          symbolSize: 8,
          symbol: 'circle',
          itemStyle: {
            color: '#0064FF',
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0, y: 0, x2: 0, y2: 1, // 渐变方向（从上到下）
              colorStops: [
                {offset: 0, color: 'rgba(0, 100, 255, 0.3)'}, // 顶部颜色
                {offset: 1, color: 'rgba(0, 100, 255, 0)'}  // 底部颜色
              ]
            }
          },
          emphasis: {
            focus: 'series',
            blurScope: 'coordinateSystem',
            itemStyle: {
              color: '#fff', // 悬停时颜色
              borderColor: '#4080FF', // 边框颜色
              borderWidth: 2, // 边框宽度
            },
          },
          data: resultData.data1
        },
        {
          name: `上月`,
          type: 'line',
          smooth: true,
          symbolSize: 8,
          symbol: 'circle',
          itemStyle: {
            color: '#A6CEE3',
          },
          emphasis: {
            focus: 'series',
            blurScope: 'coordinateSystem',
            itemStyle: {
              color: '#fff', // 悬停时颜色
              borderColor: '#A6CEE3', // 边框颜色
              borderWidth: 2, // 边框宽度
            },
          },
          data: resultData.data2
        }
      ]
    };

    const onSelectTime = (key: string) => {
      setState({searchValue: state.searchValue.queryTime === key ? {} : {queryTime: key}})
    }

    return (
        <div>
          <div style={{borderRadius: 4, background: '#fff', marginTop: 10}}>
            <div style={{padding: 10, marginLeft: 5}}>
              <STitle title={'呼出趋势图'} />
            </div>
            <div className={styles.chartBox}>
              <div className={styles.chartSelectTitle}>
                <SSegmentedTabs options={state.typeData} value={state.currentType}
                                size={'large'}
                                onChange={(type) => {
                                  setState({currentType: type})
                                }}/>
              </div>
              <ReactECharts option={option}/>
            </div>
          </div>
        </div>
    );
  }
